import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_TASKS,
	GET_TASKS_DROPDOWNS,
	TOGGLE_BRIDGE_CREATION_DIALOG,
	GET_SUMMARY_TABLES,
	GET_MOCN_TABLE,
	GET_PROXIMITY_TABLE
} from '../actions/BridgeCallActions';

const initialState = {
	tasks: [],
	dropdowns: [],
	bridgeCallDto: [],
	tableId: '',
	creationBridgeCallDialogVisibility: false,
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const bridgeCallReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_TASKS: {
						return {
							...state,
							tasks: action.tasks
						};
					}
					case GET_TASKS_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case TOGGLE_BRIDGE_CREATION_DIALOG: {
						return {
							...state,
							creationBridgeCallDialogVisibility: action.visible
						};
					}
					case GET_SUMMARY_TABLES: {
						return {
							...state,
							summaryTables: action.summaryTables
						};
					}
					case GET_MOCN_TABLE: {
						return {
							...state,
							mocnTable: action.mocnTable
						};
					}
					case GET_PROXIMITY_TABLE: {
						return {
							...state,
							proximityTable: action.proximityTable
						};
					}
					default: {
						return state;
					}
	}
};

export default bridgeCallReducer;
